<template>
  <div class="container container-custom margin_30_95">
    <section class="add_bottom_45">
      <div class="main_title_3">
        <span><em></em></span>
        <h2>Recent Offers</h2>
        <p>Cum doctus civibus efficiantur in imperdiet deterruisset.</p>
      </div>
      <div class="row">
        <div class="col-xl-3 col-lg-6 col-md-6">
          <a href="hotel-detail.html" class="grid_item">
            <figure>
              <div class="score"><strong>8.9</strong></div>
              <img
                src="../../public/frontend/img/hotel_1.jpg"
                class="img-fluid"
                alt=""
              />
              <div class="info">
                <div class="cat_star">
                  <i class="icon_star"></i><i class="icon_star"></i
                  ><i class="icon_star"></i><i class="icon_star"></i>
                </div>
                <h3>Mariott Hotel</h3>
              </div>
            </figure>
          </a>
        </div>
        <!-- /grid_item -->
        <div class="col-xl-3 col-lg-6 col-md-6">
          <a href="hotel-detail.html" class="grid_item">
            <figure>
              <div class="score"><strong>7.9</strong></div>
              <img
                src="../../public/frontend/img/hotel_2.jpg"
                class="img-fluid"
                alt=""
              />
              <div class="info">
                <div class="cat_star">
                  <i class="icon_star"></i><i class="icon_star"></i
                  ><i class="icon_star"></i><i class="icon_star"></i>
                </div>
                <h3>Concorde Hotel</h3>
              </div>
            </figure>
          </a>
        </div>
        <!-- /grid_item -->
        <div class="col-xl-3 col-lg-6 col-md-6">
          <a href="hotel-detail.html" class="grid_item">
            <figure>
              <div class="score"><strong>7.0</strong></div>
              <img
                src="../../public/frontend/img/hotel_3.jpg"
                class="img-fluid"
                alt=""
              />
              <div class="info">
                <div class="cat_star">
                  <i class="icon_star"></i><i class="icon_star"></i
                  ><i class="icon_star"></i><i class="icon_star"></i>
                </div>
                <h3>Louvre Hotel</h3>
              </div>
            </figure>
          </a>
        </div>
        <!-- /grid_item -->
        <div class="col-xl-3 col-lg-6 col-md-6">
          <a href="hotel-detail.html" class="grid_item">
            <figure>
              <div class="score"><strong>8.9</strong></div>
              <img
                src="../../public/frontend/img/hotel_4.jpg"
                class="img-fluid"
                alt=""
              />
              <div class="info">
                <div class="cat_star">
                  <i class="icon_star"></i><i class="icon_star"></i
                  ><i class="icon_star"></i><i class="icon_star"></i>
                </div>
                <h3>Park Yatt Hotel</h3>
              </div>
            </figure>
          </a>
        </div>
        <!-- /grid_item -->
      </div>
      <!-- /row -->
    
      <router-link to="/offer-post"><strong>View all (157) <i class="arrow_carrot-right"></i></strong
      ></router-link>
    </section>
    <!-- /section -->

    <section class="add_bottom_45">
      <div class="main_title_3">
        <span><em></em></span>
        <h2>Popular Restaurants</h2>
        <p>Cum doctus civibus efficiantur in imperdiet deterruisset.</p>
      </div>
      <div class="row">
        <div class="col-xl-3 col-lg-6 col-md-6">
          <a href="restaurant-detail.html" class="grid_item">
            <figure>
              <div class="score"><strong>8.5</strong></div>
              <img
                src="../../public/frontend/img/restaurant.jpg"
                class="img-fluid"
                alt=""
              />
              <div class="info">
                <h3>Da Alfredo</h3>
              </div>
            </figure>
          </a>
        </div>
        <!-- /grid_item -->
        <div class="col-xl-3 col-lg-6 col-md-6">
          <a href="restaurant-detail.html" class="grid_item">
            <figure>
              <div class="score"><strong>7.9</strong></div>
              <img
                src="../../public/frontend/img/restaurant.jpg"
                class="img-fluid"
                alt=""
              />
              <div class="info">
                <h3>Slow Food</h3>
              </div>
            </figure>
          </a>
        </div>
        <!-- /grid_item -->
        <div class="col-xl-3 col-lg-6 col-md-6">
          <a href="restaurant-detail.html" class="grid_item">
            <figure>
              <div class="score"><strong>7.5</strong></div>
              <img
                src="../../public/frontend/img/restaurant.jpg"
                class="img-fluid"
                alt=""
              />
              <div class="info">
                <h3>Bella Napoli</h3>
              </div>
            </figure>
          </a>
        </div>
        <!-- /grid_item -->
        <div class="col-xl-3 col-lg-6 col-md-6">
          <a href="restaurant-detail.html" class="grid_item">
            <figure>
              <div class="score"><strong>9.0</strong></div>
              <img
                src="../../public/frontend/img/restaurant.jpg"
                class="img-fluid"
                alt=""
              />
              <div class="info">
                <h3>Marcus</h3>
              </div>
            </figure>
          </a>
        </div>
        <!-- /grid_item -->
      </div>
      <!-- /row -->
      <a href="restaurants-grid-isotope.html"
        ><strong>View all (157) <i class="arrow_carrot-right"></i></strong
      ></a>
    </section>
    <!-- /section -->

    <div class="banner mb-0">
      <div
        class="wrapper d-flex align-items-center opacity-mask"
        data-opacity-mask="rgba(0, 0, 0, 0.3)"
      >
        <div>
          <small>Adventure</small>
          <h3>Your Perfect<br />Advenure Experience</h3>
          <p>Activities and accommodations</p>
          <a href="adventure.html" class="btn_1">Read more</a>
        </div>
      </div>
      <!-- /wrapper -->
    </div>
    <!-- /banner -->
  </div>
</template>

<script>
export default {};
</script>
